<template>
  <!-- 
  ValidationMode
  aggressive：入力値を変更するたび
  passive：フォームが送信されるとき
  lazy：フォーカスが外れたとき、または選択が変更されたとき（blur or change）
  eager：aggressiveとlazyの複合（一度エラーを出すと積極的になる模様）
  -->
  <ValidationProvider
    ref="prov"
    :mode="validationModeComputed"
    v-slot="{ errors }"
    :vid="vid"
    :rules="rulesComputed"
    :name="labelComputed"
    :debounce="debounce"
  >
    <v-text-field
      v-model="model"
      :class="right ? 'text-field-input input-right' : 'text-field-input'"
      ref="self"
      :label="fullLabel"
      :value="value"
      :error-messages="errors"
      :hint="hint"
      :persistent-hint="true"
      :suffix="suffixComputed"
      :type="type"
      dense
      outlined
      :prepend-icon="prependIcon"
      clearable
      clear-icon="mdi-close"
      hide-details="auto"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @keydown.enter="keydownEnter"
      @keyup.enter="keyupEnter"
      :maxlength="maxLength"
      :autofocus="autofocus"
    />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'TextFieldInput',

  components: {
    ValidationProvider,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hint: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
    prependIcon: {
      type: String,
      required: false,
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxLength: {
      //デフォルトの最大文字数を大きめに設定
      type: [String, Number],
      required: false,
      default: '100',
    },
    rules: {
      type: String,
      required: false,
      default: null,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'aggressive',
    },
    debounce: {
      type: Number,
      required: false,
      default: 0,
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    vid: {
      // 同一ラベル名を持つ項目が画面に複数ある場合に、各項目でvee-vadalidateを動作させるために指定.
      // vee-vadalidate仕様で、validation-observerタグ内で一意になるIDを振る必要がある.
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'string',
    },
    isQRField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isKeyDownEnter: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    fullLabel() {
      return this.required ? `${this.label} ${this.$t('ELE0024')}` : this.label
    },
    suffixComputed() {
      return this.suffix
    },
    requiredComputed() {
      return this.required
    },
    rulesComputed() {
      if (this.rules && this.required) {
        return `required|${this.rules}`
      } else if (this.required) {
        return 'required'
      } else if (this.rules) {
        return this.rules
      } else {
        return ''
      }
    },
    validationModeComputed() {
      return this.validationMode
    },
    labelComputed() {
      return this.label
    },
  },

  methods: {
    onBlur() {
      this.$emit('blur')
    },
    onChange() {
      this.$emit('change')
    },
    onFocus(event) {
      if (this.isQRField) {
        event.target.select()
      }
    },
    keydownEnter(event) {
      // 変換確定ではない場合のみフラグを立てる
      if (event.keyCode == 13) {
        this.isKeyDownEnter = true
      }
    },
    keyupEnter(event) {
      if (this.isKeyDownEnter) {
        this.isKeyDownEnter = false

        if (this.isQRField) {
          event.target.blur()
        }
      }
    },
    focus() {
      this.$refs.self.focus()
    },
  },
}
</script>
<style>
/* 背景色・ボーダー色指定 */
.text-field-input > .v-input__control > .v-input__slot > fieldset {
  background: #edeffd;
  /* margin-bottom: 2px; */
  border-style: solid;
  border-width: 2px;
  border-color: var(--v-primary-base);
}
/* フォーカスが外れている場合のラベル色 */
.text-field-input > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: var(--v-primary-base);
}
/** エラーメッセージの上端が欠けるのを回避 */
.text-field-input > .v-input__control .v-messages {
  margin-top: 1px;
}
/* 非活性の選択値のフォント色,ボーダー色 */
.text-field-input.v-input--is-disabled > .v-input__control > .v-input__slot > fieldset {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.26);
  border-width: 1px;
  color: #000000;
}
/* 非活性のラベル色 */
.text-field-input.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: #000000 !important;
}
</style>
